export default __webpack_public_path__ + "static/media/wallet_connect_big.ed67f60b.png";